
import { useEffect, useState, useRef, useMemo } from 'react'
import { useFetch } from '../../hooks/useFetch'
import InternalError from '../generales/InternalError'
import ModalResponseEncuesta from '../encuestas-components/ModalResponseEncuesta'
import { capitalizeFirstLetter } from '../../utils/utils'
import { lang } from '../generales/traduction'
import DateRangePicker from 'rsuite/DateRangePicker';
import { isAfter } from 'date-fns';
import 'rsuite/dist/rsuite.min.css';
import Search from '../generales/Search'
import Action from '../Action'
import LoadSimple from '../LoadSimple'
import Paginador from '../generales/Paginador'
import TableEvents from './Events/TableEvents'
import { useCallback } from 'react';
import panelFiltros from './Events/panelFiltros'
import FilterPanel from './Events/FilterPanel'
import ActiveFilterChips from './Events/ActiveFilterChips'
import Modal from 'react-modal';
import ModalAddProblem from './ModalAddProblem'
import ModalMasiveDelete from './ModalMasiveDelete';
import { exportToCsv } from '../../utils/utils'
import { getCurrentDate } from '../../utils/utils'
import useAlarmSound from './useAlarmSound';
import useAlarmVoice from "./Usealarmvoice";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    height: "85%",
    padding: "20px",
  },
};
const MasiveDeleteModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '80%',
    padding: '20px'
  },
};
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '85%',
    padding: '20px'
  },
};
const PanelEventos = ({ languaje, mode, token_item, userPermissions, dataGlobals, server, handleShowPopup, estados_list, estadoSelected, setEstadoSelected }) => {
  const dispId_default = -1
  const [internalError, setInternalError] = useState(false)
  const [capas, setCapas] = useState({})
  const global_longitud = dataGlobals.find(obj => obj.name === 'state_longitude')
  const global_latitude = dataGlobals.find(obj => obj.name === 'state_latitude')
  token_item = localStorage.getItem('access_token')
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [suveryId, setSuveryId] = useState(0)
  // console.log(ImportModalOpen)
  function closeImportModal() {
    setSuveryId(0)
    setImportModalOpen(false);
  }

  // const [ubicacion,setUbicacion]=useState({latitud:'20.01808757489169',longitud:'-101.21789252823293',groupid:0,dispId:11,templateId:0})
  const [ubicacion, setUbicacion] = useState({ latitud: global_latitude.value, longitud: global_longitud.value, groupid: 0, dispId: dispId_default, templateId: 0 })
  const [ubiActual, setUbiActual] = useState({ municipio: 'TODOS', groupid: 0, dispId: dispId_default, templateId: 0 })

  const [severityProblms, setSeverityProblms] = useState([((ubiActual.dispId == -1) ? "6" : "6")])


  const dataTechs = useFetch('cassia/tech_devices', '', '', 'GET', server)
  // const dataProxies=useFetch('zabbix/proxies','','','GET',server)
  // const dataGroups=useFetch('cassia/host_groups/by_type/1','','','GET',server)//manda el id 1 para grupos
  // const dataZones=useFetch('cassia/host_groups/by_type/2','','','GET',server)//manda el id 2 para zonas  
  const [token, setToken] = useState("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY")
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [dataProblems, setDataProblems] = useState({ data: [], loading: true, error: null })

  const dataAgencies = useFetch('cassia/exception_agencies', '', token_item, 'GET', server)
  // const dataCriticalities=useFetch('cassia/criticalities','',token_item,'GET',server)

  const [timeRefresh, setTimeRefresh] = useState(2);


  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults2, setSearchResults2] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });

  // console.log(dataUsers);
  const [searchResult, setSearchResult] = useState(null);
  const [searchResult2, setSearchResult2] = useState(null);
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [groupSelected, setgroupSelected] = useState([])
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])
  const [todoListUser, setTodoListUser] = useState({ data: [], loading: false, error: '' })
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const [editActive, setEditActive] = useState(false)
  const [ManttoData, setManttoData] = useState({
    // name:(editActive)?groupSelected.proxy_name:"",description:(editActive)?groupSelected.proxy_description:"",ip:(editActive)?groupSelected.proxy_ip:"",proxy_mode:(editActive)?groupSelected.proxy_mode:"Active"
    host: (editActive) ? groupSelected.host : "",
    name: (editActive) ? groupSelected.name : "",
    proxy_id: (editActive) ? ((groupSelected.proxy_hostid == "" || groupSelected.proxy_hostid == null) ? null : groupSelected.proxy_hostid) : null,
    description: (editActive) ? groupSelected.description : "",
    status: (editActive) ? groupSelected.status_value : 1,
    device_id: (editActive) ? ((groupSelected.technology_id == "" || groupSelected.technology_id == null) ? null : groupSelected.technology_id) : null,
    alias: (editActive) ? groupSelected.alias : "",
    location_lat: (editActive) ? groupSelected.location_lat : "",
    location_lon: (editActive) ? groupSelected.location_lon : "",
    serialno_a: (editActive) ? groupSelected.serialno_a : "",
    macaddress_a: (editActive) ? groupSelected.macaddress_a : "",
    brand_id: (editActive) ? ((groupSelected.brand_id == "" || groupSelected.brand_id == null) ? null : groupSelected.brand_id) : null,
    model_id: (editActive) ? ((groupSelected.model_id == "" || groupSelected.model_id == null) ? null : groupSelected.model_id) : null,
    agent_ip: (editActive) ? (groupSelected.agent_ip == null ? "" : groupSelected.agent_ip) : "",
    agent_port: (editActive) ? ((groupSelected.agent_port == null) ? "10050" : groupSelected.agent_port) : "10050",
    snmp_ip: (editActive) ? ((groupSelected.snmp_ip == null) ? "" : groupSelected.snmp_ip) : "",
    snmp_port: "161",// (editActive)?groupSelected.snmp_port:"",
    snmp_version: (editActive) ? groupSelected.snmp_version : 1,
    snmp_community: (editActive) ? groupSelected.snmp_community : "public",
    groupids: (editActive) ? ((groupSelected.groupids == null) ? [] : groupSelected.groupids.split(',').map(Number)) : [],
    zona_groupid: (editActive) ? (groupSelected.zona_groupid == "" ? null : groupSelected.zona_groupid) : null
  })

  const [autoRefresh, setAutoRefresh] = useState(false)

  //   useEffect(()=>{
  //     // console.log("problem loading-------------------------------------------------------------------"+dataProblems.loading)
  //     if(dataProblems.loading==false){
  //       setAutoRefresh(true)
  //     }
  //   },[dataProblems.loading])
  //    const timerRef = useRef(null);
  //  useEffect(() => {
  //   // Si el auto‑refresco está desactivado, asegúrate de limpiar
  //   if (!autoRefresh) {
  //     if (timerRef.current) clearTimeout(timerRef.current);
  //     return;                  // salimos del efecto
  //   }

  //   // Cada vez que cambie timeRefresh o se active autoRefresh => nuevo timeout
  //   timerRef.current = setTimeout(search_problems, 60000 * timeRefresh);

  //   // Limpieza: se ejecuta antes del próximo effect *y* al desmontar
  //   return () => clearTimeout(timerRef.current);
  // }, [autoRefresh, timeRefresh, search_problems]);















  /****************************************************************** */

  /****************************************************************** */

  /****************************************************************** */

  /****************************************************************** */
  let currentController = null;
  const controllerRef = useRef(null);





  const Exportar = (file_type) => {

    let method = 'POST'
    const body = {
      "file_type": file_type,
      "audit_ids": poolRows
    }
    setExportLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(method,server.url+'/api/v1/cassia/tech_devices/export')

        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/audit/export', {
          method: method,
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(body),
        });
        //  console.log(response)
        if (response.ok) {
          // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Dependiendo del tipo de archivo, nombramos el archivo a descargar
          if (file_type === 'json') {
            link.download = 'Tech.json';
          } else if (file_type === 'csv') {
            link.download = 'Tech.csv';
          } else if (file_type === 'excel') {
            link.download = 'Tech.xlsx'; // Archivo de Excel
          }

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setAllSelected(false)
          setPoolRows([])
          setExportLoading(false);
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])), '', true)

        } else {
          setExportLoading(false);
          throw new Error('Error en la solicitud');
        }
      } catch (error) {

      }
    };

    // fetchDataPost();
    exportToCsv('Eventos_' + getCurrentDate() + '.csv', poolObjectRows, setExportLoading);
    setAllSelected(false)
    setPoolRows([])
    setPoolObjectRows([])
    handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])), '', true)


  }



  const handleSelectChange = (e) => {
    setLimitList(e.target.value); setPageActual(1);
  };




  useEffect(() => {
    setInternalError(false)
    search_todoListUser()
    loadFiltersFromLocalStorage();
    // search_problems()
    // search_downs()

  }, [])
  const [response, setResponse] = useState(null);
  const [wsAnalisis, setWsAnalisis] = useState(null);
  const contProblemAux = useRef(-1);
  const topIdEvent = useRef(-1)
  const contWsAux = useRef(false);
  const [dataAnalisis, setDataAnalisis] = useState({ data: {}, loading: true, error: {} })

  const [events, setEvents] = useState([]);
  const [topEvents, setTopEvents] = useState([]);

  const wsRef = useRef(null);
  useEffect(() => {
    const ws = new WebSocket(`${server.ws}/api/v1/cassia/alerts_ws/`);
    wsRef.current = ws;

    ws.onopen = () => {
      setDataAnalisis({ data: [], loading: true, error: {} });
      setLoading(true);
    };

    ws.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        contWsAux.current = true
        // Normalizar siempre como array
        const eventsArray = Array.isArray(response) ? response : [response];

        setEvents(eventsArray.filter(e => !e.correlated_event_id));
        setTopEvents(eventsArray.filter(e => !e.correlated_event_id).slice(0, 5));
        setLoading(false);
        setDataAnalisis({ data: eventsArray.filter(e => !e.correlated_event_id), loading: false, error: {} });
      } catch (err) {
        // console.error("Error parseando mensaje:", err);
      }
    };

    ws.onerror = (error) => {
      // console.error("Error en el WebSocket:", error);
      setLoading(false);
      setDataAnalisis((prev) => ({ ...prev, error }));
    };

    ws.onclose = () => {
      // console.log("WebSocket cerrado");
    };

    return () => {
      ws.close();
    };
  }, [server.ws]);


  // const [events, setEvents] = useState(dataAnalisis.data);

  const [search, setSearch] = useState("");
  const [severityFilter, setSeverityFilter] = useState([6]);
  const [statusFilter, setStatusFilter] = useState(["PROBLEM", "RESOLVED"]);
  const [techFilter, setTechFilter] = useState([]);
  // console.log(techFilter)
  const [groupFilter, setGroupFilter] = useState([]);
  const [zoneFilter, setZoneFilter] = useState([]);
  const [ackFilter, setAckFilter] = useState([]); // true / false / null
  const [ticketFilter, setTicketFilter] = useState([]);
  const [tipoFilter, setTipoFilter] = useState([]);
  const [showFilters, setShowFilters] = useState(false);


  // var dataList = searchTerm === "" ? events: searchResults
  const filteredEvents = useMemo(() => {
    // return (searchTerm2 === "" ? (searchTerm === "" ? events:searchResults):(searchTerm === "" ? searchResults2:searchResults)).filter((e) => {
    // const matchesSearch =
    return events.filter((e) => {
      //           const  matchesSearch2 = (e, attributeName) => {


      //   // Lógica para buscar en un atributo específico
      //   const value = e['affiliation'];

      //     // Si el valor es un array, itera sobre él
      //     if (Array.isArray(value)) {
      //       return value.some(item => String(item).toLowerCase().includes(searchTerm2));
      //     }
      //     // Si no es un array, verifica directamente
      //     return String(value).toLowerCase().includes(searchTerm2);


      //   // Si el atributo no existe o el valor es nulo, no hay coincidencia

      // };
      // console.log(searchTerm)
      const matchesSearch = searchTerm === '' ||
        Object.values(e).some(value => {
          if (Array.isArray(value)) {
            return value.some(item => String(item).toLowerCase().includes(searchTerm.toLowerCase()));
          }
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        });
      const matchesSearch2 = searchTerm2 === '' ||
        String(e.affiliation ?? '')
          .toLowerCase()
          .includes(searchTerm2.toLowerCase());

      // const matchesSearch = searchTerm === '' || 
      //           Object.values(e).some(value => {
      //               // Asegúrate de manejar correctamente los arrays
      //               if (Array.isArray(value)) {
      //                   // Si el valor es un array, verifica si algún elemento incluye el término
      //                   return value.some(item => String(item).toLowerCase().includes(searchTerm));
      //               }
      //               // Si el valor no es un array, verifica si el valor incluye el término
      //               return String(value).toLowerCase().includes(searchTerm);
      //           });

      // console.log(e, severityFilter.includes(6), (e.tipo === 1 &&
      //     (e.item_key == 'icmpping' || e.alert_type == 'correlation')) )
      const matchesSeverity = severityFilter.length === 0 ||
        (severityFilter.includes(6) ?
          ((e.tipo === 1 &&
            (e.item_key == 'icmpping' || e.alert_type == 'correlation')) || severityFilter.includes(e.severity))
          : severityFilter.includes(e.severity))
      // severityFilter.length === 0 || severityFilter.includes(e.severity);
      // const matchesSeverity =
      //   statusFilter.length === 0 ||
      //   severityFilter.includes(e.severity) ||
      //   (

      //     (e.tipo === 1 &&
      //     (e.item_key === 'icmpping' || e.alert_type === 'correlation'))
      //   );
      const matchesStatus =
        statusFilter.length === 0 || statusFilter.includes(e.Estatus); // Asegúrate de que coincida con la propiedad 'Estatus'
      // const matchesTech = techFilter.length === 0 || e.tech_id?.some((t) => techFilter.includes(Number(t)));

      const matchesTech =
        techFilter.length === 0 ||
        techFilter.some((tech) => Number(tech.value) === Number(e.tech_id));
      const matchesGroup =
        groupFilter.length === 0 ||
        e.hostgroup_ids && // <-- Validación clave aquí
        e.hostgroup_ids
          .split(',') // Divide el string "166,175" en un array ["166", "175"]
          .some((groupId) =>
            groupFilter.some((filterObj) => Number(filterObj.value) === Number(groupId))
          );
      const matchesZone =
        zoneFilter.length === 0 ||
        e.zone_ids && // <-- Validación clave aquí
        e.zone_ids
          .split(',') // Divide el string "166,175" en un array ["166", "175"]
          .some((groupId) =>
            zoneFilter.some((filterObj) => Number(filterObj.value) === Number(groupId))
          );

      const matchesAck =
        ackFilter.length === 0 || ackFilter.length === 2 ||
        (ackFilter.includes(1) && e.acknowledges_concatenados != null && e.acknowledges_concatenados !== "") ||
        (ackFilter.includes(0) && (e.acknowledges_concatenados == null || e.acknowledges_concatenados === ""));
      const matchesTicket =
        ticketFilter.length === 0 || ticketFilter.length === 2 || // Si el filtro no está activo, se muestra todo.
        (ticketFilter.includes(1) && !(
          (e.ticket_id == null || e.ticket_id === "") &&
          (e.ticket_status == null || e.ticket_status === "")
        )) || // Si el filtro es "con ticket", se muestra si no cumple la condición de no tenerlo.
        (ticketFilter.includes(0) &&
          (e.ticket_id == null || e.ticket_id === "") &&
          (e.ticket_status == null || e.ticket_status === ""));
      saveFiltersToLocalStorage()
      setPageActual(1)
      setLimitList(50)
      const matchesTipo = tipoFilter.length === 0 || tipoFilter.includes(e.alert_type);
      return (
        matchesSearch2 &&
        matchesSearch &&
        matchesSeverity &&
        matchesStatus &&
        matchesTech &&
        matchesGroup &&
        matchesZone &&
        matchesAck &&
        matchesTicket &&
        matchesTipo
      );
    });

  }, [events, searchTerm2, severityFilter, statusFilter, techFilter, groupFilter, zoneFilter, ackFilter, ticketFilter, searchTerm, tipoFilter]);
  function saveFiltersToLocalStorage() {
    const filtersState = {
      searchTerm: searchTerm,
      searchTerm2: searchTerm2,
      severities: severityFilter,
      statuses: statusFilter,
      techs: techFilter,
      groups: groupFilter,
      zones: zoneFilter,
      ack: ackFilter,
      ticket: ticketFilter,
      tipo: tipoFilter,
    };
    localStorage.setItem('eventFilters', JSON.stringify(filtersState));
  }
  function loadFiltersFromLocalStorage() {
    const savedFilters = localStorage.getItem('eventFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      setSearchTerm2(filters.searchTerm2 || '');
      setSearchTerm(filters.searchTerm || '');
      setSeverityFilter(filters.severities || []);
      setStatusFilter(filters.statuses || []);
      setTechFilter(filters.techs || []);
      setGroupFilter(filters.groups || []);
      setZoneFilter(filters.zones || []);
      setAckFilter(filters.ack || []);
      setTicketFilter(filters.ticket || []);
      setTipoFilter(filters.tipo || []);
    }
  }

  // console.log(filteredEvents);
  var dataList = filteredEvents.length > 0 ? filteredEvents : [];

  const contProblem = dataList.filter(elemento => elemento.Estatus === 'PROBLEM').length;
  const contResolved = dataList.filter(elemento => elemento.Estatus === 'RESOLVED').length;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;

  const [severityOptions, setSeverityOptions] = useState([])
  const [statusOption, setStatusOption] = useState(['PROBLEM', 'RESOLVED'])
  // --- Filtros aplicados ---

  // console.log(events)
  const total = filteredEvents.length;
  const problemas = filteredEvents.filter((e) => e.status === "PROBLEMA").length;
  const resueltos = filteredEvents.filter((e) => e.status === "RESUELTO").length;
  const [filters, setFilters] = useState(() => {
    // Load initial state from local storage or set defaults
    const savedFilters = localStorage.getItem('eventFilters');
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        searchTerm: '',
        severities: [],
        statuses: ['PROBLEMA'],
        techs: [],
        groups: [],
        zones: [],
        ack: null,
        ticket: null,
      };
  });
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const [isOpen, setIsOpen] = useState(false);
  const togglePanel = () => {
    setIsOpen(!isOpen);
  };
  const handleRemoveFilter = (filterType) => {
    switch (filterType) {
      case 'status':
        setStatusFilter([]);
        break;
      case 'severity':
        setSeverityFilter([]);
        break;
      case 'tech':
        setTechFilter([]);
        break;
      case 'group':
        setGroupFilter([]);
        break;
      case 'zone':
        setZoneFilter([]);
        break;
      case 'ack':
        setAckFilter([]);
        break;
      case 'ticket':
        setTicketFilter([]);
        break;
      case 'tipo':
        setTipoFilter([]);
        break;
      default:
        break;
    }
  };
  const [loadingM, setLoadingM] = useState(false);
  //  const [todoListUser, setTodoListUser]=useState({data:[], loading:false ,error:''})
  // const todoListUser=useFetch('cassia/user/to_do_events','',token_item,'GET',props.server)
  const search_todoListUser = () => {


    setTodoListUser({ data: todoListUser.data, loading: true, error: '' })
    const fetchDataPost = async () => {

      try {
        // let urlSource=(source=='byGroupID')?'host_groups/hosts_list/'+brand.groupid:'hosts/byTemplateID/'+brand.templateid
        // console.log('/api/v1/cassia/'+urlSource)
        const response = await fetch(server.url + '/api/v1/cassia/user/to_do_events', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          // body:JSON.stringify(host_list)
        });
        if (response.ok) {
          const data1 = await response.json();
          setLoadingM(false)

          setTodoListUser({ data: data1.data, loading: false, error: '' })
        } else {
          const data1 = await response.json();
          // handleShowPopup('Error!!!',data1.detail,capitalizeFirstLetter(lang[languaje]['reportError']), false)
          // setError(error)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        // const data1 = await response.json();
        // handleShowPopup('Error!!!','',capitalizeFirstLetter(lang[languaje]['reportError']), false)
        // setError(error)
        console.error(error);
      }
    };

    fetchDataPost();

  }
  // const navigate = useNavigate();
  const AddTodoLst = () => {
    const mergedArray = todoListUser.data.event_ids.concat(poolRows);
    setAutoRefresh(false)
    setLoadingM(true)
    const fetchDataPost = async () => {

      try {
        const response = await fetch(server.url + '/api/v1/cassia/user/to_do_events/', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify({
            "event_ids": mergedArray
          })
        });
        setTodoListUser(prev => ({
          ...prev,
          data: {
            ...prev.data,
            event_ids: mergedArray
          }
        }));
        //  console.log(response)
        if (response.ok) {

          const data1 = await response.json();
          setLoadingM(false)
          setPoolRows([]);
          setPoolObjectRows([])
          // Manejo de la respuesta
          // setData(data1)

          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), 'eventos agregados correctamente a lista personal ', '', true)
          // const url = window.location.origin + '/todoList';
          // window.open(url, '_blank');
          // setTimeout( window.open(url, '_blank'),2000)

          // console.log(data1);
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']), capitalizeFirstLetter(lang[languaje]['reportError']), false)
        // setError(error)
        // console.error(error);
      }
    };

    fetchDataPost();
  }
  const OpenTodoLst = () => {
    const url = window.location.origin + '/todoList';
    window.open(url, '_blank');
  }
  const [modalAddCorIsOpen, setAddCorIsOpen] = useState(false);
  const [modalMasiveDeleteIsOpen, setMasiveDeleteIsOpen] = useState(false);
  function openModalMasiveDelete() {
    setMasiveDeleteIsOpen(true);
  }

  function closeModalMasiveDelete() {
    setMasiveDeleteIsOpen(false);
  }
  function openModalAddCor() {
    setAddCorIsOpen(true);
  }

  function closeModalAddCor() {
    setPoolObjectRows([])
    setPoolRows([])
    setAllSelected(false)
    setAddCorIsOpen(false);
  }
  const { playAlarm, stopAlarm } = useAlarmSound({ type: 'medical', volume: 0.5 });
  const { speak, stopVoice } = useAlarmVoice({ pitch: 0.5, rate: 0.8, repeat: false });


  useEffect(() => {
    if (events[0] != undefined) {
      if (topIdEvent.current === -1 || contWsAux.current === false) {
        // Primera vez — solo guardamos el valor base
        topIdEvent.current = events[0].eventid;
        contWsAux.current = false;

      } else if ((events[0].eventid !== topIdEvent.current) && (events[0].eventid > topIdEvent.current) && contWsAux.current) {
        contWsAux.current = false;
        // Cambió — disparamos la alarma
        speak('Alerta crítica: host caído');
        topIdEvent.current = events[0].eventid; // actualizamos la referencia
      }
    }
  }, [events])
  // useEffect(() => {
  //   console.log("cambio de variable--->  anterior: " +contProblemAux.current+"  nuevo: "+contProblem);

  //   if (contProblemAux.current === -1 ||  contWsAux.current===false || (contProblem <= contProblemAux.current)) {
  //     // Primera vez — solo guardamos el valor base
  //     contProblemAux.current = contProblem;
  //     contWsAux.current = false;

  //   } else if ((contProblem !== contProblemAux.current) && (contProblem > contProblemAux.current) && contWsAux.current) {
  //     contWsAux.current = false;
  //     // Cambió — disparamos la alarma
  //     speak('Alerta crítica: host caído');
  //     console.log('Alerta crítica disparada',contProblemAux.current,contProblem);
  //     contProblemAux.current = contProblem; // actualizamos la referencia
  //   }else{

  //   }
  // }, [contProblem]);
  try {
    return (
      // <>
      //   <div className='contMonitorMovil'>
      //     <Modal
      //             isOpen={ImportModalOpen}
      //             // isOpen={false}
      //             // onAfterOpen={afterOpenExeption}
      //             onRequestClose={closeImportModal}
      //             style={CreateCisModalStyles}
      //             contentLabel="Example Modal2"
      //             // shouldCloseOnOverlayClick={false}
      //           >
      //           <ModalResponseEncuesta
      //           server={server}
      //           suveryId={suveryId}
      //           closCreateCisModal={closeImportModal}
      //           languaje={languaje}
      //           mode={mode}
      //           handleShowPopup={handleShowPopup}
      //         ></ModalResponseEncuesta>
      //         </Modal>
      //         </div>  
      // </>
      <>
        <div className='head-reportes' style={{ height: '8%', justifyContent: 'end' }}>
          {/* <div className="selected-range">
               <p>Rango seleccionado: {range[0] ? range[0].toLocaleString() : 'N/A'} - {range[1] ? range[1].toLocaleString() : 'N/A'}</p>
             </div> */}
          <div className='cont-chips-filters' style={{ display: 'flex', alignItems: 'center', height: '100%', marginLeft: '10px', width: '90%' }}>
            <ActiveFilterChips
              statusFilter={statusFilter}
              severityFilter={severityFilter}
              techFilter={techFilter}
              groupFilter={groupFilter}
              zoneFilter={zoneFilter}
              ackFilter={ackFilter}
              ticketFilter={ticketFilter}
              tipoFilter={tipoFilter}
              onRemoveFilter={handleRemoveFilter}
            />
          </div>
          <div className='contSearchBtnrange' style={{ left: '0%', position: 'relative' }}>
            <div className='compactSearchBtnrange'>
              <Action disabled={false} origen={isOpen ? 'Red' : 'Azul'} titulo={isOpen ? capitalizeFirstLetter(lang[languaje]['cerrarFiltros']) : capitalizeFirstLetter(lang[languaje]['abrirFiltros'])} action={() => togglePanel()} />
              <FilterPanel statusFilter={statusFilter}
                techFilter={techFilter}
                groupFilter={groupFilter}
                zoneFilter={zoneFilter}
                ackFilter={ackFilter}
                ticketFilter={ticketFilter}
                severityFilter={severityFilter}
                tipoFilter={tipoFilter}
                // Pasa las funciones 'setter' para que el hijo pueda actualizarlos
                setStatusFilter={setStatusFilter}
                setTechFilter={setTechFilter}
                setGroupFilter={setGroupFilter}
                setZoneFilter={setZoneFilter}
                setAckFilter={setAckFilter}
                setTicketFilter={setTicketFilter}
                setTipoFilter={setTipoFilter}
                setSeverityFilter={setSeverityFilter} ManttoData={ManttoData} setManttoData={setManttoData} languaje={languaje} server={server} isOpen={isOpen} yourData={dataTechs.data.data} filters={filters} onFilterChange={handleFilterChange} />


            </div>

          </div>

          {/* <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
               <div className="form-GS-box" style={{height:'40%'}}> 
                                           
                                           
                                           
                                           
                                           </div>
               </div> */}


        </div>
        <div className='head-cis' style={{ height: '12%' }}>

          <div className='title-cis' >
            <div className={" event-mix cont-result-registers" + mode} style={{ width: '30%', left: '30%', bottom: 'unset', position: 'absolute' }}>
              <Search
                searchResults={searchResults}
                setSearchResults={setSearchResults}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                onSearch={handleSearch}
                dataObject={dataList}
                setDataObject={setDataUsers}
                searchResult={searchResult}
                setSearchResult={setSearchResult}
                languaje={languaje}
                titulo={capitalizeFirstLetter(lang[languaje]['busquedaGeneral']) + ' (ip / host / ' + lang[languaje]['fecha'] + ' / etc)...'}
              />
            </div>

            <div className={" cont-result-registers" + mode} style={{ width: '20%', left: '5%', position: 'absolute' }}>
              <p style={{ textAlign: "center" }}>
                &nbsp;
                {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados']) + " (" +
                  dataList.length +
                  ") "
                }
              </p>

            </div>
            <div className={" event-mix cont-result-registers" + mode} style={{ width: '20%', left: '65%', bottom: 'unset', position: 'absolute' }}>
              <Search
                searchResults={searchResults2}
                setSearchResults={setSearchResults2}
                searchTerm={searchTerm2}
                setSearchTerm={setSearchTerm2}
                onSearch={handleSearch}
                dataObject={dataList}
                setDataObject={setDataUsers}
                searchResult={searchResult2}
                setSearchResult={setSearchResult2}
                languaje={languaje}
                titulo={capitalizeFirstLetter(lang[languaje]['buscarAfiliacion']) + ' ...'}
                attr={'affiliation'}
              />

            </div>
            <div className={"cont-result-registers" + mode} style={{ width: '20%', left: '5%', display: 'flex', bottom: '0px', position: 'absolute', right: '5%', justifyContent: 'space-between' }}>

              <div style={{ textAlign: "center", color: 'var(--green)', height: '100%' }}>

                {capitalizeFirstLetter(lang[languaje]['resuelto']) + " (" +
                  contResolved +
                  ") "
                }
              </div>
              <div style={{ textAlign: "center", color: 'red', height: '100%' }}>

                {capitalizeFirstLetter(lang[languaje]['problema']) + " (" +
                  contProblem +
                  ") "
                }
              </div>
            </div>

          </div>

        </div>
        <div className='cont-cis' style={{ height: '80%' }}>
          <>
            <div className="main-panel-cis">
              <div className="compact-content-portafolio">
                <div className={"content-portafolio-head" + mode}>
                  {
                    // (contRowsSelected!=0)?
                    <>
                      {(false) ? <div className="cont-excels-buttons-portafolio cont-result-registers" style={{ position: 'absolute' }}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div> :
                        <>
                          {/* <div className="cont-display-paginador" style={{width:'40%',left:'-30%'}}>
                    <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {(loadingM)?'agregando a lista personal ....':
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={(poolRows.length==0)?"actDisabled":" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{AddTodoLst()}} disabled={(poolRows.length==0)}>Agregar a lista personal</button>
                              </div>
                              }
                    </div>
                     <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{OpenTodoLst()}} disabled={false}>ver  lista personal</button>
                              </div>
                              }
                    </div>
                  </div> */}
                          {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                              left: '70%',
                              position: 'absolute'
                            }}
                          >
                            {/* Botón outline: +Evento Correlacionado */}
                            <button
                              onClick={() => openModalAddCor()}
                              disabled={poolRows.length === 0}
                              style={{
                                height: 20,
                                padding: '0 14px',
                                borderRadius: 999,
                                border: `1px solid ${poolRows.length === 0 ? '#cbd5e1' : '#1a56db'}`,
                                background: '#ffffff',
                                color: poolRows.length === 0 ? '#94a3b8' : '#1a56db',
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: poolRows.length === 0 ? 'not-allowed' : 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6,
                                whiteSpace: 'nowrap',
                                transition: 'all 0.15s ease',
                                opacity: poolRows.length === 0 ? 0.6 : 1,
                              }}
                              onMouseEnter={(e) => {
                                if (poolRows.length === 0) return;
                                e.currentTarget.style.background = '#e8f0fe';
                              }}
                              onMouseLeave={(e) => {
                                if (poolRows.length === 0) return;
                                e.currentTarget.style.background = '#ffffff';
                              }}
                            >
                              <span style={{ fontSize: 14, lineHeight: 1, fontWeight: 700 }}>+</span>
                              {capitalizeFirstLetter(lang[languaje]['eventoCorrelacionado'])}
                            </button>

                            {/* Botón sólido rojo: Cierre Masivo */}
                            <button
                              onClick={() => openModalMasiveDelete()}
                              style={{
                                height: 20,
                                padding: '0 16px',
                                borderRadius: 999,
                                border: 'none',
                                background: '#ef4444',
                                color: '#ffffff',
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                                transition: 'all 0.15s ease',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = '#dc2626';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = '#ef4444';
                              }}
                            >
                              {capitalizeFirstLetter(lang[languaje]['cierreMasivo'])}
                            </button>
                          </div>
                          <div className="cont-excels-buttons-portafolio" style={{ position: 'absolute' }}>
                            <div className="half-excels-buttons-portafolio">

                              <div className="body-half-excels-buttons-portafolio">
                                {

                                  <img
                                    className="img-dwnld-portafolio"
                                    src={"/iconos/csv_icon.png"}
                                    name="regresar"
                                    onClick={() => Exportar('csv')}
                                    style={{
                                      opacity: (contRowsSelected == 0) ? '0.3' : '1',
                                      pointerEvents: (contRowsSelected == 0) ? 'none' : 'auto'
                                    }}
                                  />
                                }
                              </div>
                              <div className={"top-half-excels-buttons-portafolio" + mode} >
                                {'CSV  '}
                              </div>
                            </div>
                            {/* <div className="half-excels-buttons-portafolio">
                      
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/json_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('json')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                        {'JSON'}
                      </div>
                    </div> */}
                            {/* <div className="half-excels-buttons-portafolio">
                    
                      <div className="body-half-excels-buttons-portafolio">
                      {
                        
                        <img
                  className="img-dwnld-portafolio"
                  src={"/iconos/xsl_icon.png"}
                  name="regresar"
                  onClick={()=>Exportar('excel')}
                  style={{opacity:(contRowsSelected==0)? '0.3':'1',
                    pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
                />
                      }
                      </div>
                      <div className={"top-half-excels-buttons-portafolio"+mode} >
                      {'EXCEL'}
                      </div>
                    </div> */}
                          </div>
                        </>
                      }
                    </>
                    // :''
                  }
                </div>
                <div className="content-portafolio">
                  <div className="cont-portafolio-table">
                    <div className="content-card-portafolio" id="content">
                      {(exportLoading || dataAgencies.loading) ? (
                        <LoadSimple />
                      ) : (
                        <>

                          <TableEvents
                            pageActual={pageActual}
                            limitList={limitList} startLimit={startLimit}
                            dataList={dataList}
                            // cisSelected={cisSelected}
                            // setCisSelected={setCisSelected}
                            // registerIsValid={registerIsValid}
                            searchResults={searchResults}
                            setSearchResults={setSearchResults}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            dataUsers={dataUsers}
                            setDataUsers={setDataUsers}
                            server={server}
                            // setRegisterIsValid={setRegisterIsValid}
                            setData={setData}
                            setLoading={setLoading}
                            setError={setError}
                            // handleChangEdit={handleChangEdit}
                            // devices={devices}
                            languaje={languaje}
                            mode={mode}
                            setContRowSelected={setContRowSelected}
                            poolRows={poolRows}
                            setPoolRows={setPoolRows}
                            allSelected={allSelected}
                            setAllSelected={setAllSelected}
                            setPoolObjectRows={setPoolObjectRows}
                            handleShowPopup={handleShowPopup}
                            setImportModalOpen={setImportModalOpen}
                            setSuveryId={setSuveryId}
                            ubiActual={ubiActual}
                            // search_problems={search_problems}
                            dataAgencies={dataAgencies}
                            origen={'eventos'}
                            userPermissions={userPermissions}
                          ></TableEvents>

                        </>
                      )}
                    </div>
                  </div>

                </div>
                <div className={"content-portafolio-footer" + mode}>
                  {/* <div className="cont-display-paginador" style={{width:'40%'}}>
                    <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {(loadingM)?'agregando a lista personal ....':
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={(poolRows.length==0)?"actDisabled":" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{AddTodoLst()}} disabled={(poolRows.length==0)}>Agregar a lista personal</button>
                              </div>
                              }
                    </div>
                     <div className={"cont-half-display-paginador display-paginador-mini"} style={{width:'100%'}}>
                    {
                      <div className='contBtnCorrelacion' style={{position:'absolute',right:'20%',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                              <button class={" actAzul "} style={{minHeight:'unset',height:'2vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{OpenTodoLst()}} disabled={false}>ver  lista personal</button>
                              </div>
                              }
                    </div>
                  </div> */}
                  <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                    <div className={"cont-half-display-paginador" + mode}>
                      <p style={{ textAlign: "center" }}>
                        &nbsp;
                        {(contRowsSelected != 0) ? "(" + contRowsSelected + ")  " + capitalizeFirstLetter(lang[languaje]['registosSeleccionados']) : ''}
                      </p>

                    </div>
                  </div>
                  <div className="cont-display-paginador">
                    <Paginador pages={pages}
                      pageActual={pageActual}
                      setPageActual={setPageActual}
                      mode={mode}></Paginador>
                  </div>
                  <div className="cont-display-paginador">
                    <div className={"cont-half-display-paginador" + mode}>

                      <div>
                        <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                        <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                          <option value={10}>10</option>
                          <option value={50} >50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                          <option value={1000}>1000</option>
                        </select>


                      </div>
                    </div>
                    <div className={"cont-half-display-paginador" + mode}>
                      <p style={{ textAlign: "center" }}>
                        &nbsp;
                        {"(" +
                          (startLimit + 1) +
                          " - " +
                          (dataList.length > parseInt(pageActual) * parseInt(limitList)
                            ? parseInt(pageActual) * parseInt(limitList)
                            : dataList.length) +
                          ")  " + lang[languaje]['de'] + " " +
                          dataList.length +
                          " " + lang[languaje]['resultados']}
                      </p>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <Modal
              isOpen={modalAddCorIsOpen}
              // onAfterOpen={afterOpenModal}
              onRequestClose={closeModalAddCor}
              style={addHostModalStyles}
              contentLabel="Example Modal"
            >
              <ModalAddProblem editActive={false} poolObjectRows={poolObjectRows} setPoolObjectRows={setPoolObjectRows} poolRows={poolRows} server={server} handleShowPopup={handleShowPopup} setPoolRows={setPoolRows} languaje={languaje} mode={mode} closeAddHostModal={closeModalAddCor} />
            </Modal>
            <Modal
              isOpen={modalMasiveDeleteIsOpen}
              // onAfterOpen={afterOpenModal}
              onRequestClose={closeModalMasiveDelete}
              style={MasiveDeleteModalStyles}
              contentLabel="Example Modal"
            >
              <ModalMasiveDelete server={server} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} closeModalMasiveDelete={closeModalMasiveDelete} />
            </Modal>

            {/* <Modal
      isOpen={ImportModalOpen}
      // isOpen={false}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closeImportModal}
      style={ImportModalStyles}
      contentLabel="Example Modal2"
      shouldCloseOnOverlayClick={false}
    >
    <ImportInfo
    server={server}
    importLoading={importLoading}
    setImportLoading={setImportLoading}
    closeImportModal={closeImportModal}
    languaje={languaje}
    mode={mode}
    handleShowPopup={handleShowPopup}
  ></ImportInfo>
  </Modal> */}
          </>

        </div>
      </>
    );
  } catch (error) {
    return (
      <InternalError />
    )
  }
}

export default PanelEventos